export enum AuthType {
  LOGIN = "login",
  REGISTER = "register"
}
export enum ThirdPartyAuthProviders {
  GOOGLE = "google",
  FACEBOOK = "facebook"
}

export enum UserRoles {
  user = "user"
}

export type CurrentUser = {
  uid: string;
  role: UserRoles;
  email: string;
} | null;
